import axios from 'axios';
import { API_CONFIG } from '@/constants/apiEndpoints';
import { logger } from '@/utils/logger';

const publicApi = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: API_CONFIG.TIMEOUT,
});

// Retry interceptor for transient failures
publicApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    const status = error.response?.status;

    // Don't retry when the request opts out (e.g. large media uploads), on
    // client errors (except 429), or once already retried 3 times.
    if (!config || config.skipRetry || config._retryCount >= 3) {
      return Promise.reject(error);
    }
    if (status && status >= 400 && status < 500 && status !== 429) {
      return Promise.reject(error);
    }

    config._retryCount = (config._retryCount || 0) + 1;

    // Exponential backoff: 1s, 2s, 4s
    const delay = Math.pow(2, config._retryCount - 1) * 1000;

    if (status === 429) {
      logger.warn(`[publicApi] Rate limited, retrying in ${delay}ms (attempt ${config._retryCount}/3)`);
    } else {
      logger.warn(`[publicApi] Network error, retrying in ${delay}ms (attempt ${config._retryCount}/3)`);
    }

    await new Promise((resolve) => setTimeout(resolve, delay));
    return publicApi(config);
  }
);

export default publicApi;
